import { ReactNode } from "react";

import Modal, { ModalProps } from "ui/Modal";
import VisibilityTracker, {
  VisibilityTrackerProps,
} from "ui/VisibilityTracker";

export interface ActionModalProps
  extends Omit<ModalProps, "size">,
    Omit<VisibilityTrackerProps, "children"> {
  children?: ReactNode;
  image?: ReactNode;
  title: string;
  subtitle?: ReactNode;
}

/**
 * Provides a structured interface for building modals that follow our standard
 * design pattern, while still allowing flexibility to customize the content.
 */
function ActionModal({
  analyticsName,
  analyticsSurface,
  analyticsProperties,
  children,
  container,
  image,
  title,
  subtitle,
  ...props
}: ActionModalProps) {
  return (
    <VisibilityTracker
      analyticsName={analyticsName}
      analyticsSurface={analyticsSurface}
      analyticsProperties={analyticsProperties}
      container={container}
    >
      <Modal {...props}>
        <Modal.Header>
          {image && <Modal.Image>{image}</Modal.Image>}
          <Modal.Title>{title}</Modal.Title>
          {subtitle && <Modal.Subtitle>{subtitle}</Modal.Subtitle>}
        </Modal.Header>
        {children}
      </Modal>
    </VisibilityTracker>
  );
}

// Re-export subcomponents from `Modal` for convenience.
ActionModal.Body = Modal.Body;
ActionModal.Footer = Modal.Footer;
ActionModal.PrimaryButton = Modal.PrimaryButton;
ActionModal.SecondaryButton = Modal.SecondaryButton;
ActionModal.PrimaryButtonTransparent = Modal.PrimaryButtonTransparent;

export default ActionModal;
